'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var mediaQueries = {
  xs: '(max-width: 599px)',
  sm: '(max-width: 959px)',
  md: '(max-width: 1279px)',
  lg: '(max-width: 1919px)'
};
var MediaQueryContext = React.createContext({});
MediaQueryContext.displayName = 'MediaQueryContext';
function MediaQueryProvider(_ref) {
  var children = _ref.children,
      queries = _ref.queries;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      currentSizes = _useState2[0],
      setCurrentSize = _useState2[1];

  React.useEffect(function () {
    var mediaQueryLists = {};
    var queriesKeys = Object.keys(queries);
    var isAttached = false;

    var handleQueryListener = function handleQueryListener() {
      var updatedMatches = queriesKeys.reduce(function (acc, media) {
        acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
        return acc;
      }, {});
      setCurrentSize(updatedMatches);
    };

    if (window && window.matchMedia) {
      var matches = {};
      queriesKeys.forEach(function (media) {
        mediaQueryLists[media] = window.matchMedia(queries[media]);
        matches[media] = mediaQueryLists[media].matches;
      });
      setCurrentSize(matches);
      isAttached = true;
      queriesKeys.forEach(function (media) {
        mediaQueryLists[media].addListener(handleQueryListener);
      });
    }

    return function () {
      if (isAttached) {
        queriesKeys.forEach(function (media) {
          mediaQueryLists[media].removeListener(handleQueryListener);
        });
      }
    };
  }, [queries]);
  return /*#__PURE__*/React__default.createElement(MediaQueryContext.Provider, {
    value: currentSizes
  }, children);
}

exports.MediaQueryContext = MediaQueryContext;
exports.default = MediaQueryProvider;
exports.mediaQueries = mediaQueries;
